import React from "react";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { MdMenu } from "react-icons/md";
import { useNavigate } from "react-router-dom";

const pages = [
  { label: "Заявки", path: "/orders/sos" },
  { label: "Пользователи", path: "/users" },
  { label: "OTP кулдауны", path: "/otp-cooldowns" },
  { label: "Аналитика", path: "/dashboards" },
];

export const HeaderNavigation = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null,
  );
  const navigate = useNavigate();

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    handleCloseNavMenu();
  };

  return (
    <React.Fragment>
      <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
        <IconButton
          size="large"
          aria-label="open navigation menu"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleOpenNavMenu}
          color="inherit"
        >
          <MdMenu />
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          keepMounted
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          open={Boolean(anchorElNav)}
          onClose={handleCloseNavMenu}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          {pages.map(({ label, path }) => (
            <MenuItem key={path} onClick={() => handleNavigate(path)}>
              <Typography sx={{ textAlign: "center" }}>{label}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Box
        sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, px: 1, gap: 1 }}
      >
        {pages.map(({ label, path }) => (
          <Button
            key={path}
            onClick={() => handleNavigate(path)}
            sx={{ my: 2, color: "white", display: "block" }}
          >
            {label}
          </Button>
        ))}
      </Box>
    </React.Fragment>
  );
};
